import { render, staticRenderFns } from "./DeleteRecapAddition.vue?vue&type=template&id=70a918e9&"
import script from "./DeleteRecapAddition.vue?vue&type=script&lang=js&"
export * from "./DeleteRecapAddition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1928246051/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a918e9')) {
      api.createRecord('70a918e9', component.options)
    } else {
      api.reload('70a918e9', component.options)
    }
    module.hot.accept("./DeleteRecapAddition.vue?vue&type=template&id=70a918e9&", function () {
      api.rerender('70a918e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecapAdditions/DeleteRecapAddition.vue"
export default component.exports